import { combineReducers } from "@reduxjs/toolkit";
import { initialState as behaviorInitialState, behaviorReducer, } from "./behaviorSlice";
import { initialState as dependenciesInitialState, dependenciesReducer, } from "./dependenciesSlice";
import { initialState as secretInitialState, secretsReducer, } from "./secretsSlice";
import { initialState as vulnerabilitiesInitialState, vulnerabilitiesReducer, } from "./vulnerabilitiesSlice";
export const fileBrowserReducer = combineReducers({
    behavior: behaviorReducer,
    dependencies: dependenciesReducer,
    vulnerabilities: vulnerabilitiesReducer,
    secrets: secretsReducer,
});
export const fileBrowserInitialState = {
    behavior: behaviorInitialState,
    dependencies: dependenciesInitialState,
    vulnerabilities: vulnerabilitiesInitialState,
    secrets: secretInitialState,
};
//# sourceMappingURL=index.js.map